import { render, staticRenderFns } from "./AccountFranchisorDashboardCard.vue?vue&type=template&id=e186ca4e&scoped=true&"
var script = {}
import style0 from "./AccountFranchisorDashboardCard.vue?vue&type=style&index=0&id=e186ca4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e186ca4e",
  null
  
)

export default component.exports